var r = /* @__PURE__ */ ((t) => (t.ImprClientName = "Impr-Client-Name", t.ImprCodingCtx = "Impr-Coding-Ctx", t.ImprInAppSession = "Impr-In-App-Session", t.ImprSessionId = "Impr-Session-Id", t.ImprTenantId = "Impr-Tenant-Id", t.ImprWorkflowId = "Impr-Workflow-Id", t.StrictTransportSecurity = "Strict-Transport-Security", t.XContentTypeOptions = "X-Content-Type-Options", t.XFrameOptions = "X-Frame-Options", t.XSSProtection = "X-XSS-Protection", t))(r || {}), o = /* @__PURE__ */ ((t) => (t.V2 = "v2", t.V3 = "v3", t))(o || {});
const s = 500, u = [502, 503, 504];
var e = /* @__PURE__ */ ((t) => (t.CANCEL = "cancel", t.TIMEOUT = "timeout", t))(e || {}), i = /* @__PURE__ */ ((t) => (t.APP = "app", t.SYSTEM = "system", t))(i || {});
function S(t) {
  return (t || {}).error !== void 0;
}
function C(t) {
  if (S(t))
    return !0;
  const n = t;
  return n && typeof n == "object" ? n.code !== void 0 || n.message !== void 0 : !1;
}
var p = /* @__PURE__ */ ((t) => (t[t.X_RAY = 0] = "X_RAY", t[t.DYNATRACE = 1] = "DYNATRACE", t))(p || {});
export {
  i as ApiErrorType,
  o as ApiVersion,
  r as ImprHeaders,
  u as OFFLINE_STATUS_CODES,
  s as SERVER_ERROR_STATUS_CODE,
  e as TERMINATE_REASON_CODE,
  p as TracingSolutionType,
  S as isApiError,
  C as isApiErrorLike
};
//# sourceMappingURL=types.es.js.map
